






import { Component, Inject, Mixins } from "vue-property-decorator";
import { IProductConfigProviderData } from "@/models/providers/products";
import { ICrumb } from "@/components/app-base/UBreadcrumbs.vue";
import Context from "@/mixins/context";
import { QUERY_PARAMS } from "@/data/constants";

@Component
export default class ProductBreadcrumbs extends Mixins(Context) {
  // Inject
  @Inject({ from: "productConfigProviderData" })
  public readonly $productConfigData!: () => IProductConfigProviderData;

  // Computed
  public get $product() {
    return this.$productConfigData();
  }

  public get breadcrumbs(): ICrumb[] {
    return [
      ...this.$_.map(this.$product.categories, category => ({
        label: category.name,
        route: {
          to: {
            name: this.isAdmin ? "adminOrderShop" : "orderShopStep",
            query: {
              ...this.$_.omitBy(
                this.$_.omit(this.$router.currentRoute.query, [
                  QUERY_PARAMS.CATEGORY_ID,
                  QUERY_PARAMS.BASKET_PRODUCT_ID,
                  QUERY_PARAMS.PRODUCT_ID,
                  QUERY_PARAMS.CROSS_SELL_PRODUCT,
                  QUERY_PARAMS.BILLING_CYCLE_MONTHS,
                  QUERY_PARAMS.READ_MORE,
                  QUERY_PARAMS.SEARCH,
                  QUERY_PARAMS.SUBPRODUCT_IDS,
                  QUERY_PARAMS.QUANTITY
                ]),
                (value, key) =>
                  this.$_.includes(key, QUERY_PARAMS.SUBPRODUCT_QUANTITY)
              ),
              [QUERY_PARAMS.CATEGORY_ID]: `${category.id}`
            }
          }
        }
      })),
      {
        label: this.$product.name
      }
    ];
  }
}
